"use strict";

exports.__esModule = true;

var ConsoleAppender =
/** @class */
function () {
  function ConsoleAppender() {}

  ConsoleAppender.prototype.append = function (_a) {
    var category = _a.category,
        action = _a.action,
        label = _a.label,
        value = _a.value;
    console.log("MetricsEvent. %cCategory: " + category + ", %cAction: " + action + ", %cLabel: " + label + ", %cValue: " + value, 'color:#de54a7', 'color:#9c54de', 'color:#dec054', 'color:#54b1de');
  };

  return ConsoleAppender;
}();

exports.ConsoleAppender = ConsoleAppender;